import { createSlice } from '@reduxjs/toolkit'
import { keys, omit } from 'ramda'
import { MigrationReducer } from './model'

export const defaultState: MigrationReducer = {
  lastMigrationByVmId: {},
}

// This is deprecated in favor of using migrations nova API
const {
  name: customMigrationKey,
  reducer: migrationReducers,
  actions: migrationActions,
} = createSlice({
  name: 'migrations',
  initialState: defaultState,
  reducers: {
    newMigrations: (state, { payload }) => {
      const { vms, destination } = payload
      const currentMigrations = state.lastMigrationByVmId
      const updatedMigrations = vms.reduce((accum, vm) => {
        return {
          ...accum,
          [vm.id]: {
            // Consider using host ID instead if needed
            startHost: vm['OS-EXT-SRV-ATTR:hypervisor_hostname'],
            // Perhaps this is not needed at all? Difficult to dispatch with refreshed VMs, perhaps only need to store the starting host here.
            endHost: destination,
          },
        }
      }, currentMigrations)
      return {
        lastMigrationByVmId: updatedMigrations,
      }
    },
    removeMigration: (state, { payload }) => {
      const { id, startHost } = payload
      const currentMigrations = state.lastMigrationByVmId
      if (startHost) {
        const migration = currentMigrations[id]
        // If another migration was started before removeMigration
        // was triggered in timeout
        if (migration && migration.startHost !== startHost) {
          return state
        }
      }
      const updatedMigrations = omit([id], currentMigrations)
      return {
        lastMigrationByVmId: updatedMigrations,
      }
    },
    // refreshedVms: (state, { payload }) => {
    //   const { vms } = payload
    //   const vmsById = vms.reduce((accum, vm) => {
    //     return {
    //       ...accum,
    //       [vm.id]: vm,
    //     }
    //   }, {})
    //   const currentMigrations = state.lastMigrationByVmId
    //   const currentMigrationVmIds = keys(currentMigrations)
    //   const updatedMigrations = currentMigrationVmIds.reduce((accum, id) => {
    //     const vm = vmsById[id]
    //     if (vm['OS-EXT-STS:task_state'] === 'migrating') {
    //       return accum
    //     }
    //     return {
    //       ...accum,
    //       [vm.id]: {
    //         ...accum[vm.id],
    //         endHost: vm['OS-EXT-SRV-ATTR:hypervisor_hostname'],
    //       },
    //     }
    //   }, currentMigrations)
    //   return {
    //     lastMigrationByVmId: updatedMigrations,
    //   }
    // },
    clearMigrations: () => {
      return defaultState
    },
  },
})

export { customMigrationKey, migrationActions }
export default migrationReducers
